import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import {
    Card,
    CardBody,
    CardHeader,
    ModalProgressBar
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import {
    NotificationManager,
    NotificationContainer,
  } from "react-notifications";
const CommonForm = (props) => {
    const suhbeader = useSubheader();
    const dispatch = useDispatch();
    const [title, setTitle] = useState("");
    const { id } = useParams();
    let history = useHistory();
    const [frmInitialValues, setFrmInitialValues] = useState(
        {
            name: '',
            isActive: true,
            company: "",
        }
    );
    const [
        companySelectedDropdownFilterData,
        setCompanySelectedDropdownFilterData,
      ] = useState(null);
      const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
        []
      );
    // Validation schem
    const LevelsEditSchema = Yup.object().shape({
        name: Yup.string()
            
            .required("Name is required"),

    });

    const { currentState } = useSelector(
        (state) => ({ currentState: state.couponCategories }),
        shallowEqual
    );
    const { actionsLoading, couponCategoryForEdit, company } = currentState
    useEffect(() => {
        dispatch(actions.fetchCompanyList());
      }, []);
    
      useEffect(() => {
        let tempb = [];
        const userdata = JSON.parse(localStorage.getItem("userData"));
        const userCompany = userdata?.company || [];
    
        for (let i = 0; i < company?.length; i++) {
        //   if (!helperFunc.isAdmin()) {
            if (userCompany.includes(company[i]._id)) {
              let obj = {};
              obj.label = company[i]?.name;
              obj.value = company[i]?._id;
              obj.code = company[i]?.code;
              tempb.push(obj);
            }
        //   } else {
        //     let obj = {};
        //     obj.label = company[i]?.name;
        //     obj.value = company[i]?._id;
        //     obj.code = company[i]?.code;
        //     tempb.push(obj);
        //   }
        }
    
        setCompanyDropdownFilterData(tempb);
      }, [company]);

    useEffect(() => {
        dispatch(actions.fetchSingle(id));
    }, [id, dispatch]);

    useEffect(() => {
        let _title = id ? "" : "New Coupon Category";
        if (couponCategoryForEdit && id) {
            _title = `Edit Coupon Category '${couponCategoryForEdit.item && couponCategoryForEdit.item.name}'`;
            const item = couponCategoryForEdit.item
            const data = { ...frmInitialValues, ...item };
            setCompanySelectedDropdownFilterData({
                value: couponCategoryForEdit?.company?._id, 
                label: couponCategoryForEdit?.company?.name, 
            });
            setFrmInitialValues(data);
        }
        setTitle(_title);
        suhbeader.setTitle(_title);
    }, [couponCategoryForEdit, id]);

    const saveLevel = (values) => {
        console.log("totstttt", companySelectedDropdownFilterData.value)
        values.company = companySelectedDropdownFilterData.code;
      
        if (!id) {
          // Create new item
          dispatch(actions.createItem(values)).then((success) => {
            if (success) {
            //   toast.success("Item created successfully!"); // Display success toast
              setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
            }
          });
        } else {
          // Update existing item
          dispatch(actions.updateItem(values)).then((success) => {
            if (success) {
            //   toast.success("Item updated successfully!"); // Display success toast
              setTimeout(() => backToList(), 2000); // Redirect after 2 seconds
            }
          });
        }
      };
    const backToList = () => {
        history.push(`/coupon-categories/list`);
        window.location.reload();
    };

    return (
        <Card>
          <NotificationContainer />
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}></CardHeader>
            <CardBody>
                <Formik
                    enableReinitialize={true}
                    initialValues={frmInitialValues}
                    validationSchema={LevelsEditSchema}
                    onSubmit={(values) => {
                        saveLevel(values);
                    }}
                >
                    {({ handleSubmit, values }) => (
                        <Form className="form form-label-right">
                            <div className="form-group row">
                            <div className="col-lg-4 col-md-6 mt-2">
                                <label>
                                    Select Company{" "}
                                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                                </label>
                                {console.log("testttt", frmInitialValues)}
                                <DropdownReactSelect
                                    placeholder={"Select Company"}
                                    name={"company"}
                                    value={companySelectedDropdownFilterData || frmInitialValues?.company}
                                    isMulti={false}
                                    isClearable={true}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    options={companyDropdownFilterData}
                                    onChange={setCompanySelectedDropdownFilterData}
                                />
                            </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                        name="name"
                                        component={Input}
                                        placeholder="Name"
                                        label="Name"
                                        isRequired={true}
                                    />
                                </div>
                                <div className="col-md-2">
                                    <label className="col-form-label">Is Active</label>
                                    <div className="col-12 w-100 p-0">
                                        <span className="switch switch-primary switch-icon">
                                            <label>
                                                <Field type="checkbox" name="isActive" />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group justify-content-end row mx-0">
                                <button
                                    type="button"
                                    onClick={backToList}
                                    className="btn btn-light"
                                >
                                    <i className="fa fa-arrow-left"></i>Back
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary ml-2"
                                >{id ? "Update" : "Save"}</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </CardBody>
        </Card>
    )
}
export default CommonForm;